export default __webpack_public_path__ + "static/The Adventure_image 5@2x-3cf11130ed8894954e4d54998eda0405.jpg";